import { render } from "./RuiBalon.vue?vue&type=template&id=684b016a"
const script = {}
script.render = render

export default script